import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, Box } from '@mui/material';
import Page from '../../../../components/Page';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
import P2bTransactionsData from './p2bTrasactionsData';

const P2bTransactions = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Handling Change when tab is changed
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // console.log('table data', tableData);

  return (
    <Page title="P2B Transaction Report">
      <HeaderBreadcrumbs
        heading="P2B Transaction Report"
        links={[{ name: 'P2B Transaction' }]}
      />
      <Box sx={{ width: '100%' }}>
        <P2bTransactionsData />
      </Box>
    </Page>
  );
};

export default P2bTransactions;
